import { render } from "./DischargeDropsReport.vue?vue&type=template&id=4b6f12c9"
import script from "./DischargeDropsReport.vue?vue&type=script&lang=js"
export * from "./DischargeDropsReport.vue?vue&type=script&lang=js"

import "./DischargeDropsReport.vue?vue&type=style&index=0&id=4b6f12c9&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__